import { useCallback, useState } from 'react';
import type { NativeScrollEvent, NativeSyntheticEvent } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const useBagRewardsRail = (params: Params) => {
  const { rewardsCount, lastItemOffset = 500 } = params;

  // ─── State ───────────────────────────────────────────────────────────

  const [currentRailWidth, setCurrentRailWidth] = useState(0);
  const [currentlyScrolledReward, setCurrentlyScrolledReward] = useState(0);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleOnScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      const scrollAmount = event.nativeEvent.contentOffset.x;

      const itemWidth = currentRailWidth / rewardsCount;
      const halfWidth = itemWidth / 2;

      const scrolledReward = Math.min(
        Math.floor((scrollAmount + halfWidth) / itemWidth),
        rewardsCount - 1,
      );

      const isScrollingToLastReward = scrolledReward === rewardsCount - 2;
      const shouldIndicateLastReward =
        currentRailWidth - scrollAmount < lastItemOffset;

      const rewardToIndicate =
        isScrollingToLastReward && shouldIndicateLastReward
          ? rewardsCount - 1
          : scrolledReward;

      setCurrentlyScrolledReward(rewardToIndicate);
    },
    [currentRailWidth, lastItemOffset, rewardsCount],
  );

  // ─────────────────────────────────────────────────────────────────────

  return {
    handleOnScroll,
    setCurrentRailWidth,
    currentlyScrolledReward,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  lastItemOffset?: number;
  rewardsCount: number;
};
